import ApPanel from "../..";

import data from "../../../../data/other-floors/data.json";

export default function PanelOtherFloors() {
  return (
    <ApPanel.Cards title="Andares Anteriores" cards={data} />
  );
};
